import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApiVolumeSlice } from './get';

import { coreDataSecurityApiVolumeByApplicationReducers, coreDataSecurityApiVolumeByApplicationWatchers } from './applications';
import { coreDataSecurityApiVolumeTableExportReducers, coreDataSecurityApiVolumeTableExportWatchers } from './export';

export const coreDataSecurityApiVolumeReducers = combineReducers({
	applications: coreDataSecurityApiVolumeByApplicationReducers,
	export: coreDataSecurityApiVolumeTableExportReducers,
	get: getCoreDataSecurityApiVolumeSlice.asyncReducers
});

export const coreDataSecurityApiVolumeWatchers = combineAllWatchers([
	coreDataSecurityApiVolumeByApplicationWatchers,
	coreDataSecurityApiVolumeTableExportWatchers,
	getCoreDataSecurityApiVolumeSlice.asyncWatchers
]);
